document.addEventListener("DOMContentLoaded", function () {
  const popup = document.getElementById("similar-products-popup");
  const container = document.getElementById("similar-products-container");

  // Delegate: handle clicks on any .similar_products_trigger (new or old)
  document.addEventListener("click", (e) => {
    const btn = e.target.closest(".similar_products_trigger");
    if (btn) {
      const productId = btn.dataset.productId;
      const template = document.getElementById(`similar-products-template-${productId}`);
      if (template) {
        container.innerHTML = template.innerHTML;
        popup.classList.add("active");
        document.body.classList.add("overflow-hidden");
      }
    }
  });

  // Close popup (overlay or close button)
  popup.addEventListener("click", (e) => {
    if (
      e.target.classList.contains("similar-popup") ||
      e.target.closest(".popup-close")
    ) {
      popup.classList.remove("active");
      document.body.classList.remove("overflow-hidden");
    }
  });
});
